import __request__ from "routing/request";
export function pauseProcessing() {
  return __request__("PUT", "/system/processing/pause", null, {}, {
    "Accept": []
  });
}
export function resumeProcessing() {
  return __request__("PUT", "/system/processing/resume", null, {}, {
    "Accept": []
  });
}
